






















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateShopBankCard, QueryBankCodeList,QueryBankCardByShopId ,QueryBankBranchList,ChangeBankCardApply} from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import Rules from '@/utils/rules'
import constan from '@/utils/constant'
import { VImageUpload } from '@/components/upload'
import LLpayChangeBankCardApplyDialog from './LLpayChangeBankCardApplyDialog.vue'
import pcaData from '@/assets/pca.json'
import constant from '@/utils/constant'

@Component({
  components: {VImageUpload,LLpayChangeBankCardApplyDialog},
})
export default class ChangeBankCardDialog extends Vue {
  private show = false
  private data: any ={
    bankType: 1,
    bankCode: undefined,
    bankName: undefined,
    accountName: '',
    accountNo: ''
  }
  private shop:any = {}
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    // 银行卡信息
    'bankType': [this.requiredRule],
    'bankCode': [this.requiredRule],
    'branchCode': [this.requiredRule],
    'accountName': [this.requiredRule],
    'accountNo': [this.requiredRule],
    'settleCardFrontPicList': [this.requiredRule],

    // 对私银行卡额外字段
    'bindMobilePhone': [this.requiredRule],
    'certNo': [this.requiredRule],
    'certValidityType': [this.requiredRule],
    'certBeginDate': [this.requiredRule],
    'certEndDate': [this.requiredRule],
    'settleCertBackPicList': [this.requiredRule],
    'settleCertFrontPicList': [this.requiredRule],
  }
  private type = 'add'
  private ValidityType = constant.ValidityType
  private pca = pcaData

  // 银行列表
  private bankList: any[] = []

  // 获取省数据
  private get provinceList() {
    return this.pca
  }
  // 获取市数据
  private get cityList() {
    if (!this.data.province) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.data.province)
    if (t.length <= 0) {
      return []
    }
    return t[0].children
  }
  private get bankCityList() {
    if (!this.data.province) {
      return []
    }
    const t = this.pca.filter((e: any) => e.name == this.data.province)
    if (t.length <= 0) {
      return []
    }
    return t[0].children
  }

  private get isPreview() {
    if (this.type == 'preview') {
      return true
    }
    return false
  }

  @Emit('close')
  private close() {
    (this.$refs.form as ElForm).resetFields()
    this.show = false
    this.data = {
      bankType: 1,
      bankCode: undefined,
      bankName: undefined,
      accountName: '',
      accountNo: ''
    }
  }

  public created() {
    // 加载银行卡列表
    QueryBankCodeList({}).then(res => {
      this.bankList = res.list
    })
  }


  public async open(shop:any) {
    this.show = true
    this.shop = shop

    this.loadBankCard()

  }

  private changeBankProvice(){
    this.data.city = undefined
    this.data.branchCode = ''
    this.loadBankBranch()
  }

  private bankCardLoading = false
  private loadBankCard(){
    if(!this.shop.id){
      this.$message.error("店铺id不存在")
      return
    }
    this.bankCardLoading = true
    QueryBankCardByShopId({id:this.shop.id}).then((res:any)=>{
      this.data = res

      if (this.data.settleCardFrontPic) {
        this.data.settleCardFrontPicList = this.data.settleCardFrontPic.split(',').map((e: string) => {
          return { url: e }
        })
      } else {
        this.data.settleCardFrontPic = undefined
        this.data.settleCardFrontPicList = []
      }

      if (this.data.settleCertBackPic) {
        this.data.settleCertBackPicList = this.data.settleCertBackPic.split(',').map((e: string) => {
          return { url: e }
        })
      } else {
        this.data.settleCertBackPic = undefined
        this.data.settleCertBackPicList = []
      }

      if (this.data.settleCertFrontPic) {
        this.data.settleCertFrontPicList = this.data.settleCertFrontPic.split(',').map((e: string) => {
          return { url: e }
        })
      } else {
        this.data.settleCertFrontPic = undefined
        this.data.settleCertFrontPicList = []
      }

      // 加载支行
      this.loadBankBranch2()

      this.bankCardLoading = false

    }).catch(err=>{
      this.bankCardLoading =  false
    })
  }

  private bankChange() {
    const res = this.bankList.filter(e => e.bankCode == this.data.bankCode)
    if (res.length > 0) {
      this.data.bankName = res[0].bankName
      this.data.branchCode = undefined
      this.loadBankBranch()
    } else {
      this.data.bankName = ""
    }
  }

  private selectBankBranch = ''
  private bankBranchList  = []
  private bankBranchLoading = false
  private loadBankBranch(text = undefined){
    this.bankBranchLoading = true
    // 加载支行
    if(this.data.bankCode && this.data.province){
      const res = this.bankList.filter(e => e.bankCode == this.data.bankCode)
      const param: any = {bankCode:res[0].huifuBankCode}
      if(this.data.province){
        param.branchName = this.data.province
      }
      if(text){
        param.branchName = text
      }
      QueryBankBranchList(param).then(res=>{
        this.bankBranchList = res
        this.bankBranchLoading = false
      })
    }
  }
  // 加载默认的支行
  private loadBankBranch2(text = undefined){
    this.bankBranchLoading = true
    // 加载支行
    if(this.data.bankCode && this.data.province){
      const res = this.bankList.filter(e => e.bankCode == this.data.bankCode)
      const param: any = {bankCode:res[0].huifuBankCode}
      if(this.data.branchCode){
        param.branchCode = this.data.branchCode
      }
      QueryBankBranchList(param).then(res=>{
        this.bankBranchList = res
        this.bankBranchLoading = false
      })
    }
  }

  public async save() {

    this.data.settleCardFrontPic = this.data.settleCardFrontPicList?.map((e: any) => e.url).join(',');
    this.data.settleCertBackPic = this.data.settleCertBackPicList?.map((e: any) => e.url).join(',');
    this.data.settleCertFrontPic = this.data.settleCertFrontPicList?.map((e: any) => e.url).join(',');

    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }

      const d = this.$refs.LLpayChangeBankCardApplyDialog as any
      d.open(this.data)

      // ChangeBankCardApply(this.data).then(res=>{
      //   if(res){
      //     Message.success('申请成功')
      //     // 输入验证码
      //     if(res.needVerify){
      //       console.log("输入验证码")
      //     } else {
      //       this.$message.info("已提交申请，等待完成")
      //       this.close()
      //     }
      //   }
      // })

    })
  }


}
